import { ReactNode } from "react";
import { ChevronRight } from "lucide-react";

type Breadcrumb = {
  label: string;
  href?: string;
};

type Props = {
  title: string;
  breadcrumbs?: Breadcrumb[];
  description?: string;
  actions?: ReactNode;
};

const SectionTitle = ({ title, breadcrumbs, description, actions }: Props) => {
  return (
    <div className="flex flex-col sm:flex-row sm:items-start sm:justify-between gap-4">
      <div className="flex flex-col gap-1.5 flex-1 min-w-0">
        {breadcrumbs && breadcrumbs.length > 0 && (
          <nav className="text-sm text-gray-500">
            <ol className="flex flex-wrap items-center gap-1.5">
              {breadcrumbs.map((crumb, index) => (
                <li key={index} className="flex items-center gap-1.5">
                  {index > 0 && <ChevronRight className="w-4 h-4 text-gray-400" />}
                  {crumb.href ? (
                    <a 
                      href={crumb.href} 
                      className="hover:text-palomma-primary transition-colors"
                    >
                      {crumb.label}
                    </a>
                  ) : (
                    <span className="text-gray-700">{crumb.label}</span>
                  )}
                </li>
              ))}
            </ol>
          </nav>
        )}
        <h1 className="text-2xl md:text-3xl font-bold text-gray-900 tracking-tight">
          {title}
        </h1>
        {description && (
          <p className="text-sm text-gray-600 mt-1">{description}</p>
        )}
      </div>
      {actions && (
        <div className="flex gap-3 shrink-0">
          {actions}
        </div>
      )}
    </div>
  );
};

export default SectionTitle;
